import { BookingProvider, Path } from "@common/constans";
import Avatar from "@components/Avatar";
import Divider from "@components/general/Divider";
import DropDown from "@components/general/form/DropDown";
import Icon from "@components/general/Icon";
import Popover from "@components/general/Popover";
import { UserMenu } from "@components/profile";
import { Culture } from "@core/index";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import Translate from "@service/Translate";
import { loadLocale } from "@utilize/Init";
import { FC, RefObject } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

interface IHeaderAccountSectionProps {
    headerRef: RefObject<HTMLHeadElement>;
}

const HeaderAccountSection: FC<IHeaderAccountSectionProps> = () => {
    const { tr } = Translate;
    const { push } = useHistory();
    const { location } = useHistory();
    const { abbreviation, code } = Culture.getLocale();
    const { user, showHeaderSkeleton, languages } = useSelector((state: IAppState) => ({
        user: state.user,
        showHeaderSkeleton: state.showHeaderSkeleton,
        languages: state.languages
    }));

    return (
        <section className="header-account-section">
            {
                Config.config.defaultBookingProvider === BookingProvider.Mahan ?
                    <>
                        <Popover
                            content={<UserMenu />}
                            placement="bottom-end"
                            closeEventId="profile"
                            disable={!user.memberId || showHeaderSkeleton}
                        >
                            <Avatar />
                        </Popover>
                        <Avatar onClick={() => push(Path.Profile.Home)} />
                        <Divider mode="default" orientation="vertical" />
                    </> : ''
            }
            <DropDown
                name="language"
                value={languages.find(language => language.code === code)}
                placeholder={tr("language")}
                onChange={(name: string, value: any) => loadLocale(value, true, location.pathname + location.search)}
                selectOptionsMode
                dataSource={languages}
                valueKey="code"
                displayFormat="title"
            />
            <div className="language">
                <Icon name="icon-language" />
                <span className="abbr">{abbreviation}</span>
            </div>
        </section>
    )
}

export default HeaderAccountSection;